package com.snakesworld.game.ui

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.TextUnit
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.snakesworld.game.ui.theme.GameCanvasColors
import com.snakesworld.game.ui.theme.LocalGameCanvasColors
import com.snakesworld.game.ui.theme.appFontFamily
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import snakesworld.shared.generated.resources.Res
import snakesworld.shared.generated.resources.app_icon
import snakesworld.shared.generated.resources.app_name

/**
 * Primary branded "Snake World" title with the app icon beside it.
 */
@Composable
fun AppBrandTitle(
    modifier: Modifier = Modifier,
    fontSize: TextUnit = 28.sp,
    letterSpacing: TextUnit = 2.sp,
    iconSize: Dp = 32.dp,
    canvasColors: GameCanvasColors = LocalGameCanvasColors.current,
) {
    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(10.dp),
    ) {
        Image(
            painter = painterResource(Res.drawable.app_icon),
            contentDescription = stringResource(Res.string.app_name),
            modifier = Modifier.size(iconSize),
            contentScale = ContentScale.Fit,
        )
        Text(
            text = stringResource(Res.string.app_name).uppercase(),
            color = canvasColors.hudTextColor,
            fontSize = fontSize,
            fontWeight = FontWeight.Black,
            fontFamily = appFontFamily(),
            letterSpacing = letterSpacing,
        )
    }
}
